// Build and download a vCard 3.0 with an embedded logo photo.
// Works on iOS Safari, Android Chrome, Outlook, macOS Contacts, Google Contacts.

const CONTACT = {
  firstName: "bekim",
  lastName: "",
  fullName: "bekim",
  org: "bekTech",
  title: "Network & Cybersecurity Consulting",
  email: "bekim@bektechnology.com",
  phone: "+17032034949",
  phoneDisplay: "703-203-4949",
  website: "https://bektechnology.com",
  logoUrl: "/bektech-logo.jpg", // JPEG required for vCard PHOTO across most contact apps
};

// Fold a long line at 75 chars with CRLF+space per vCard 3.0 spec
function foldLine(line) {
  const max = 74;
  if (line.length <= max) return line;
  const chunks = [];
  let i = 0;
  chunks.push(line.slice(i, i + max));
  i += max;
  while (i < line.length) {
    chunks.push(" " + line.slice(i, i + max - 1));
    i += max - 1;
  }
  return chunks.join("\r\n");
}

async function fetchAsBase64(url) {
  try {
    const res = await fetch(url, { cache: "force-cache" });
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result;
        const base64 = String(dataUrl).split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export async function downloadBektechVCard() {
  const photoB64 = await fetchAsBase64(CONTACT.logoUrl);

  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${CONTACT.lastName};${CONTACT.firstName};;;`,
    `FN:${CONTACT.fullName}`,
    `ORG:${CONTACT.org}`,
    `TITLE:${CONTACT.title}`,
    `EMAIL;TYPE=INTERNET,WORK:${CONTACT.email}`,
    `TEL;TYPE=CELL,VOICE:${CONTACT.phone}`,
    `URL:${CONTACT.website}`,
  ];

  if (photoB64) {
    lines.push(foldLine(`PHOTO;ENCODING=b;TYPE=JPEG:${photoB64}`));
  }

  lines.push("END:VCARD");

  const vcard = lines.join("\r\n") + "\r\n";
  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "bekim-bekTech.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Delay revoke so mobile browsers finish reading the blob
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
